import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { brandPrimary, charmGray } from '../../../../web/styles/colors';
import { white } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		paddingLeft: 16,
		paddingRight: 16,
		paddingBottom: 16,
	},
	content: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		padding: '24px',
		width: '100%',
		maxWidth: '100%',
		overflow: 'hidden',
		color: THEME.colors.text.dark,
		boxSizing: 'border-box',
	},
	header: {
		padding: '24px 24px 16px 24px',
		marginBottom: 0,
	},
	title: {
		fontSize: '24px',
		fontWeight: 600,
		margin: 0,
	},
	description: {
		fontSize: '14px',
		margin: 0,
		lineHeight: '1.5',
		opacity: 0.9,
	},
	tableContainer: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		border: `1px solid ${charmGray}`,
		borderRadius: '8px',
	},
	bulkActionsContainer: {
		marginBottom: '16px',
		padding: '16px',
		backgroundColor: 'rgba(255, 255, 255, 0.05)',
		border: `1px solid ${charmGray}`,
		borderRadius: '8px',
	},
	bulkActionsContent: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: '12px',
	},
	selectedCount: {
		fontSize: '14px',
		fontWeight: 500,
	},
	bulkActions: {
		display: 'flex',
		gap: 12,
		flexWrap: 'wrap',
	},
	customMessageRow: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
	},
	customMessageLabel: {
		fontSize: '13px',
		fontWeight: 500,
		opacity: 0.9,
		display: 'flex',
		alignItems: 'center',
		gap: '6px',
	},
	customMessagePreview: {
		fontSize: '12px',
		fontStyle: 'italic',
		fontWeight: 'normal',
	},
	customMessagePlaceholder: {
		fontSize: '12px',
		fontWeight: 'normal',
	},
	editMessageButton: {
		padding: '4px 8px',
		backgroundColor: 'transparent',
		color: brandPrimary,
		border: `1px solid ${brandPrimary}`,
		borderRadius: '4px',
		fontSize: '12px',
		fontWeight: 500,
		cursor: 'pointer',
		transition: 'background-color 0.2s, color 0.2s',
		':hover': {
			backgroundColor: brandPrimary,
			color: '#FFFFFF',
		},
	},
	root: {
		display: 'grid',
		gridTemplateColumns: '1fr auto',
		height: '100%',
		justifyItems: 'center',
	},
	callAnalysisRoot: {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		overflowY: 'auto',
		overflowX: 'hidden',
	},
	drawer: {
		overflow: 'hidden',
	},
	drawerContent: {
		borderTopLeftRadius: 16,
	},
	tabsWrapper: {
		backgroundColor: white,
		borderRadius: 6,
		overflow: 'hidden',
		width: '100%',
	},
	tabsList: {
		backgroundColor: white,
		borderBottom: `1px solid ${charmGray}`,
		margin: '0 0 0 0',
		padding: '0 24px',
	},
	tabTrigger: {
		fontSize: 16,
		fontWeight: 500,
		padding: '12px 24px',
	},
	tabContent: {
		width: '100%',
		minHeight: 600,
	},
});
